module.exports = __webpack_public_path__ + "info_top_frame.png?5b19c5fd20584e8c789f34db52e703d8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_top_frame.png
// module id = 147
// module chunks = 0